export default "__VITE_ASSET__BIBxxnSn__"